/** Monarch/UI icon keys — shared with product-sync (no React dependency). */

export const iconTypes = [
  "access-time-filled",
  "add-shopping-cart",
  "ai",
  "arrow-right",
  "arrow-right-alt",
  "arrow-upward",
  "award",
  "book-open",
  "briefcase",
  "business",
  "calendar-checked",
  "calendar-month",
  "calendar-today",
  "celebration",
  "certificate",
  "certificate-ribbon",
  "check",
  "check-list-check",
  "chevron-left",
  "chevron-right",
  "circle",
  "circle-check",
  "circle-check-outline",
  "circle-check-fill",
  "circle-play",
  "clock",
  "close",
  "close-material",
  "close-popup",
  "compass",
  "content-copy",
  "credit-card",
  "customer-service",
  "dash",
  "data",
  "degrees",
  "earn-skills",
  "edx-by-2u",
  "event-busy",
  "facebook",
  "facebook-circle",
  "filters",
  "format-quote",
  "groups",
  "graduation-cap-growth",
  "info",
  "instructor",
  "institution",
  "keyboard-arrow-down",
  "keyboard-arrow-down-material",
  "keyboard-arrow-up",
  "language",
  "laptop",
  "launch",
  "learning-path",
  "level",
  "library-books",
  "lightbulb",
  "linkedin",
  "loading-spinner",
  "linkedin-circle",
  "location-on",
  "mail",
  "magnifying-glass",
  "money",
  "money-outline",
  "monitor",
  "number-of-courses",
  "open-quote",
  "outline-warning-circle",
  "pacing",
  "part-of-program",
  "people",
  "person",
  "play-arrow",
  "play-circle",
  "play-circle-filled",
  "popular",
  "personalized-matches",
  "program",
  "reddit",
  "sale",
  "school",
  "school-outline",
  "search",
  "see-less",
  "see-more",
  "speedometer",
  "star-filled",
  "star-outline",
  "stopwatch",
  "start-date",
  "subtitles-off",
  "time-to-complete",
  "timelapse",
  "todo-list",
  "trencher",
  "trending",
  "trending-points",
  "trending-up",
  "twitter",
  "visibility",
  "visibility-off",
  "verified-badge",
  "verified-outline",
  "warning",
  "warning-circle",
  "x",
];

/** Widen to `string` for CMS/Monarch values; use `satisfies` at call sites when narrowing. */
export type IconTypes = (typeof iconTypes)[number];
